import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=93bc6796&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=ts&"
export * from "./Items.vue?vue&type=script&lang=ts&"
import style0 from "./Items.vue?vue&type=style&index=0&id=93bc6796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bc6796",
  null
  
)

export default component.exports